module.exports = __webpack_public_path__ + "assets/img/bg1.e7291fad.png";